module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG609a2ca6473f9dec922efa2ebb16f620.b646698a.jpg";